// react
import { useEffect, useState } from "react";
// react router dom
import { useSearchParams } from "react-router-dom";
// react redux
import { useSelector } from "react-redux";
//constants
import { getAllActiveBundles } from "../../constants/endpoints/bundle";
// helpers
import { getResponseData } from "../../helpers/getResponseData";
// redux
import { selectMechanicId } from "../../redux/mechanic";
// components
import Header from "../../components/Categories/Header/Header";
import ProductsGrid from "../../components/ProductListing/ProductsGrid/ProductsGrid";
import BundlesGrid from "../../components/ProductListing/bundlesGrid/BundlesGrid";

const MechanicCollectionSkus = () => {
  const [searchParams] = useSearchParams();
  const webhookUrl = searchParams.get("webhookUrl");
  const bundleName = searchParams.get("bundleName");
  const selectedMechanicId = useSelector(selectMechanicId);

  // state
  const [skusLoading, setSkusLoading] = useState(false);
  const [skusList, setSkusList] = useState([]);
  const [bundlesList, setBundlesList] = useState([]);

  // effects
  useEffect(() => {
    const getSkus = async () => {
      setSkusLoading(true);

      try {
        // Add mechanicId for bundle requests when mechanic is selected
        let finalWebhookUrl = webhookUrl;

        if (
          (webhookUrl === getAllActiveBundles ||
            webhookUrl === "/bundle/getAllActiveBundles") &&
          selectedMechanicId
        ) {
          finalWebhookUrl = `/bundle/getAllActiveBundles?mechanicId=${selectedMechanicId}`;
        }

        const response = await getResponseData(finalWebhookUrl);

        if (
          webhookUrl === getAllActiveBundles ||
          webhookUrl?.includes("/bundle/getAllActiveBundles")
        ) {
          const {
            data: { data },
          } = response;

          setBundlesList(data);
        } else {
          const {
            data: { skuList },
          } = response;

          const skuListWithImageList = skuList.map(({ imageUrl, ...rest }) => ({
            imageList: [{ imageUrl }],
            ...rest,
          }));

          setSkusList(skuListWithImageList);
        }
      } catch (error) {
        console.log(error);
      }
      setSkusLoading(false);
    };

    getSkus();
  }, [webhookUrl, bundleName, selectedMechanicId]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header hideSearch={true} />
      <main dir="rtl">
        <div className="max-w-full mx-2 xl:max-w-1200 xl:mx-auto my-12">
          {bundlesList?.length > 0 ? (
            <BundlesGrid bundles={bundlesList} productsLoading={skusLoading} />
          ) : (
            <ProductsGrid
              skus={skusList}
              productsLoading={skusLoading}
              noPagination
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default MechanicCollectionSkus;
